import { render, staticRenderFns } from "./FormFornecedor.vue?vue&type=template&id=48077bdd"
import script from "./FormFornecedor.vue?vue&type=script&lang=js"
export * from "./FormFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports